var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.organisation === 'Nhood')?[_c('NhoodPageNotFound')]:[_c('FillitPageNotFound')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }